import type { UserType } from "@/components/user-search-modal/types";

import {
  type EscapeMutationInput,
  type EscapeType,
  type ExperienceReviewMutationInput,
  type NormalizedComponentResponse,
  PrivacyEnum,
} from "./types";

export function escapeToInput(
  escapeObj: EscapeType,
  gameId: string,
  user: UserType
) {
  const { myReview } = escapeObj;

  const { id, gameDate, escapeTime, isEscaped, pictures } = escapeObj;

  let components: NormalizedComponentResponse = {};
  const escapeInput: EscapeMutationInput = {
    escapeTime,
    game: gameId,
    gameDate,
    id,
    isEscaped,
    pictures: (pictures || []).map(({ imageKey }) => imageKey as string),
  };
  let experienceInput: ExperienceReviewMutationInput = {
    privacy: PrivacyEnum.PUBLIC,
  };
  let taggedUsers: UserType[] = [];
  if (escapeObj.taggedUsers && !!escapeObj.taggedUsers.length) {
    taggedUsers = escapeObj.taggedUsers;
  } else if (user) {
    taggedUsers = [user];
  }

  if (myReview) {
    const {
      components: userComponents,
      images,
      isContainingSpoilers,
      overallRating,
      privacy,
      privateNotes,
      summary,
    } = myReview;

    experienceInput = {
      images: (images || []).map(({ imageKey }) => imageKey) as string[],
      isContainingSpoilers,
      overallRating,
      privacy: privacy || PrivacyEnum.PUBLIC,
      privateNotes,
      summary,
    };

    if (userComponents) {
      components = userComponents.reduce((accum, { id, response }) => {
        if (response) {
          accum[id] = {
            comment: response.comment,
            option: response.optionId,
            question: id,
          };
        }

        return accum;
      }, {} as NormalizedComponentResponse);
    }
  } else if (pictures) {
    experienceInput = {
      images: (pictures || []).map(({ imageKey }) => imageKey as string),
      privacy: PrivacyEnum.PUBLIC,
    };
  }

  return { components, escapeInput, experienceInput, taggedUsers };
}
